<template>
    <v-row>
        <v-col class="my-auto" cols="12" md="4" sm="6">
            <v-menu
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="date"
                        label="Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        :rules="[v => !!v || 'Date is required']"
                        required
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                </template>
                <v-date-picker
                    v-model="date"
                    @input="dateMenu = false"
                ></v-date-picker>
            </v-menu>
        </v-col>
        <v-col class="my-auto" cols="12" md="4" sm="6">
            <v-text-field 
                dense
                prefix="$"
                v-model="amount"
                @keypress="preventNonNumericInput"
                class="py-auto"
                label="Amount"
                required
            >
                {{ amount }}
            </v-text-field>
        </v-col>
        <v-col class="py-0" cols="12">
            <v-card-actions class="pt-0">
                <v-spacer></v-spacer>
                <v-btn
                    text
                    color="green darken-2"
                    icon
                    dark
                    @click="saveEditedPayrollReport(tabItems)"
                    :loading="isSavingEditLoading"
                    :disabled="isSavingEditLoading"
                >
                    <v-icon>mdi-content-save</v-icon>
                </v-btn>
            </v-card-actions>
        </v-col>
    </v-row>
</template>

<script>
    import {mapState, mapMutations, mapActions} from "vuex";

    export default {
        props: {
            tabItems: Object,
        },

        data () {
            return {
                dateMenu: false,

                // typeOfItem: "",
                date: "",
                amount: null,

                isSavingEditLoading: false,
            }
        },
        
        created () {
            
        },

        watch: {
        },

        computed: {
            ...mapState({
                selectedUserPayrollReport: state => state.payrollReportsHistories.selectedUserPayrollReport,
                // tabItems: state => state.payrollReportsHistories.tabItems,
            })
        },

        methods: {
            ...mapMutations ({
                setSelectedCompPanel: "payrollReportsHistories/setSelectedCompPanel",
            }),

            ...mapActions("bonuses", [
                "addItem",
            ]),

            preventNonNumericInput (e) {
                const keysAllowed= ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
                const keyPressed= e.key;
                
                if (!keysAllowed.includes(keyPressed)) {
                    e.preventDefault()
                }
            },

            async saveEditedPayrollReport (tabItems) {
                this.isSavingEditLoading = true;

                // Validates the edited item
                if (this.date == "") {
                    let snackbarMsg = {
                        saveEditedPayrollReport_snackbarText: tabItems.item + " date is empty!",
                        saveEditedPayrollReport_snackbarColor: "error",
                        saveEditedPayrollReport_snackbar: true,
                    }

                    this.$emit("snackbarMsg", snackbarMsg);
                    this.isSavingEditLoading = false;
                } else if (this.amount == 0 || this.amount == null) {
                    let snackbarMsg = {
                        saveEditedPayrollReport_snackbarText: tabItems.item + " amount is 0!",
                        saveEditedPayrollReport_snackbarColor: "error",
                        saveEditedPayrollReport_snackbar: true,
                    }

                    this.$emit("snackbarMsg", snackbarMsg)
                    this.isSavingEditLoading = false;
                } else {
                    try {
                        const d = new Date(Date.now());
                        const newDate = new Date(this.date);

                        newDate.setHours(d.getHours())
                        newDate.setMinutes(d.getMinutes())
                        newDate.setSeconds(d.getSeconds())
                        newDate.setMilliseconds(d.getMilliseconds())
                        
                        var req_body = {
                            User: this.selectedUserPayrollReport._id,
                            Date: newDate.toISOString(),
                            Bonus: parseFloat(this.amount),
                            Rate: this.$store.state.staff.staff.Rate,
                        }

                        const response = await this.addItem(req_body);

                        if (response.status === 201) {
                            tabItems.itemValue = parseFloat(req_body.Bonus);

                            tabItems.isEdit = false;

                            this.date = "";
                            this.amount = null;
                            
                            this.setSelectedCompPanel(null)
                        }
                    } catch (error) {
                        this.errorMsg("adding", "record", error);
                        
                    } finally {
                        this.isSavingEditLoading = false;
                    }
                }
            },

            errorMsg(action, item, error) {
                console.error(`An error occured whiling ${action} ${item}`, error);
            },
        }
    }
</script>